
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../../style/CrearHorarioRector.css";

// const API = process.env.REACT_APP_API || "http://localhost:5001/api";

// export default function RectorHorario() {
//   const [profesores, setProfesores] = useState([]);
//   const [profesorId, setProfesorId] = useState("");
//   const [asignaciones, setAsignaciones] = useState([]);
//   const [horario, setHorario] = useState([]);
//   const [editingId, setEditingId] = useState(null);

//   const [asignacionId, setAsignacionId] = useState("");
//   const [dia, setDia] = useState("");
//   const [horaInicio, setHoraInicio] = useState("");
//   const [horaFin, setHoraFin] = useState("");
//   const [aula, setAula] = useState("");
//   const [periodo, setPeriodo] = useState("");
//   const [grado, setGrado] = useState("");
//   const [grupo, setGrupo] = useState("");
//   const [fecha, setFecha] = useState("");

//   const [consultaProfesor, setConsultaProfesor] = useState("");
//   const [consultaGrado, setConsultaGrado] = useState("Todos");
//   const [consultaGrupo, setConsultaGrupo] = useState("Todos");
//   const [consultaFechaInicio, setConsultaFechaInicio] = useState("");
//   const [consultaFechaFin, setConsultaFechaFin] = useState("");
//   const [horasConsulta, setHorasConsulta] = useState([]);

//   const [gradosDisponibles, setGradosDisponibles] = useState([]);
//   const [gruposDisponibles, setGruposDisponibles] = useState([]);

//   const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];
//   const PERIODOS = ["Primer", "Segundo", "Tercer", "Cuarto"];

//   // ====== Cargar profesores ======
//   useEffect(() => {
//     axios.get(`${API}/horario/profesores`)
//       .then(res => setProfesores(res.data))
//       .catch(err => console.error("Error cargando profesores:", err));
//   }, []);

//   // ====== Cargar asignaciones y horario del profesor seleccionado ======
//   useEffect(() => {
//     if (!profesorId) return;

//     axios.get(`${API}/horario/asignaciones/${profesorId}`)
//       .then(res => {
//         setAsignaciones(res.data);
//         setGradosDisponibles([...new Set(res.data.map(a => a.grado))]);
//         setGruposDisponibles([...new Set(res.data.map(a => a.grupo))]);
//       })
//       .catch(err => console.error("Error cargando asignaciones:", err));

//     fetchHorario();
//   }, [profesorId]);

//   const fetchHorario = () => {
//     if (!profesorId) return;
//     axios.get(`${API}/horario/${profesorId}`)
//       .then(res => setHorario(res.data))
//       .catch(err => console.error("Error cargando horario:", err));
//   };

//   // ====== Guardar horario ======
//   const handleGuardar = async (e) => {
//     e.preventDefault();
//     if (!profesorId || !asignacionId || !dia || !horaInicio || !horaFin || !periodo || !grado || !grupo || !fecha) {
//       return alert("Todos los campos son obligatorios");
//     }

//     try {
//       const payload = { 
//         profesor_id: profesorId, 
//         asignacion_id: asignacionId, 
//         dia, 
//         hora_inicio: horaInicio, 
//         hora_fin: horaFin, 
//         aula,
//         periodo,
//         grado,
//         grupo,
//         fecha
//       };

//       if (editingId) {
//         await axios.put(`${API}/horario/${editingId}`, payload);
//         setEditingId(null);
//       } else {
//         await axios.post(`${API}/horario`, payload);
//       }

//       fetchHorario();
//       resetForm();
//     } catch (err) {
//       console.error("Error guardando horario:", err);
//       alert("Error al guardar horario");
//     }
//   };

//   const resetForm = () => {
//     setAsignacionId("");
//     setDia("");
//     setHoraInicio("");
//     setHoraFin("");
//     setAula("");
//     setPeriodo("");
//     setGrado("");
//     setGrupo("");
//     setFecha("");
//     setEditingId(null);
//   };

//   const handleEditar = (h) => {
//     setEditingId(h.id);
//     setAsignacionId(h.asignacion_id);
//     setDia(h.dia);
//     setHoraInicio(h.hora_inicio);
//     setHoraFin(h.hora_fin);
//     setAula(h.aula || "");
//     setPeriodo(h.periodo || "");
//     setGrado(h.grado || "");
//     setGrupo(h.grupo || "");
//     setFecha(h.fecha || "");
//   };

//   const handleEliminar = async (id) => {
//     if (!window.confirm("¿Eliminar este horario?")) return;
//     try {
//       await axios.delete(`${API}/horario/${id}`);
//       fetchHorario();
//     } catch (err) {
//       console.error("Error eliminando horario:", err);
//       alert("Error al eliminar");
//     }
//   };

//   const handleEnviarTabla = async () => {
//     try {
//       await axios.post(`${API}/modulo-profesor/enviar-tabla`, { profesorId, horario });
//       alert("✅ Horario enviado al módulo del profesor");
//     } catch (err) {
//       console.error("Error enviando tabla:", err);
//       alert("Error enviando horario");
//     }
//   };

//   // ====== Consulta horas entre fechas ======
//   const handleConsulta = async () => {
//     if (!consultaProfesor || !consultaFechaInicio || !consultaFechaFin) {
//       return alert("Debe seleccionar profesor y rango de fechas");
//     }
//     try {
//       const gradoParam = consultaGrado === "Todos" ? "all" : consultaGrado;
//       const grupoParam = consultaGrupo === "Todos" ? "all" : consultaGrupo;
//       const res = await axios.get(`${API}/horario/consulta/${consultaProfesor}/${gradoParam}/${grupoParam}?fecha_inicio=${consultaFechaInicio}&fecha_fin=${consultaFechaFin}`);
//       setHorasConsulta(res.data.detalle || []);
//     } catch (err) {
//       console.error("Error realizando consulta:", err);
//       alert("Error realizando la consulta");
//     }
//   };

//   const handleDescargarPDF = () => {
//     if (!consultaProfesor || !consultaFechaInicio || !consultaFechaFin) return;
//     const gradoParam = consultaGrado === "Todos" ? "all" : consultaGrado;
//     const grupoParam = consultaGrupo === "Todos" ? "all" : consultaGrupo;
//     window.open(`${API}/horario/consulta/${consultaProfesor}/${gradoParam}/${grupoParam}/pdf?fecha_inicio=${consultaFechaInicio}&fecha_fin=${consultaFechaFin}`, "_blank");
//   };

//   const handleDescargarExcel = () => {
//     if (!consultaProfesor || !consultaFechaInicio || !consultaFechaFin) return;
//     const gradoParam = consultaGrado === "Todos" ? "all" : consultaGrado;
//     const grupoParam = consultaGrupo === "Todos" ? "all" : consultaGrupo;
//     window.open(`${API}/horario/consulta/${consultaProfesor}/${gradoParam}/${grupoParam}/excel?fecha_inicio=${consultaFechaInicio}&fecha_fin=${consultaFechaFin}`, "_blank");
//   };

//   return (
//     <div className="container">
//       <h1>📅 Gestión de Horarios (Rector)</h1>

//       <div className="form-group">
//         <label>Profesor:</label>
//         <select value={profesorId} onChange={e => setProfesorId(e.target.value)}>
//           <option value="">-- Seleccione --</option>
//           {profesores.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
//         </select>
//       </div>

//       {profesorId && (
//         <>
//           {/* Formulario de Horario */}
//           <form onSubmit={handleGuardar} className="form-horario">
//             <h2>{editingId ? "✏️ Editar Horario" : "➕ Agregar Horario"}</h2>
//             <div className="grid-form">
//               <select value={asignacionId} onChange={e => setAsignacionId(e.target.value)}>
//                 <option value="">-- Seleccione Asignación --</option>
//                 {asignaciones.map(a => (
//                   <option key={a.id} value={a.id}>{a.materia} ({a.grado}{a.grupo})</option>
//                 ))}
//               </select>

//               <select value={dia} onChange={e => setDia(e.target.value)}>
//                 <option value="">-- Día --</option>
//                 {DIAS.map(d => <option key={d} value={d}>{d}</option>)}
//               </select>

//               <select value={periodo} onChange={e => setPeriodo(e.target.value)}>
//                 <option value="">-- Periodo --</option>
//                 {PERIODOS.map(p => <option key={p} value={p}>{p} Periodo</option>)}
//               </select>

//               <input type="time" value={horaInicio} onChange={e => setHoraInicio(e.target.value)} />
//               <input type="time" value={horaFin} onChange={e => setHoraFin(e.target.value)} />
//               <input type="text" placeholder="Aula" value={aula} onChange={e => setAula(e.target.value)} />

//               <select value={grado} onChange={e => setGrado(e.target.value)}>
//                 <option value="">-- Seleccione Grado --</option>
//                 {gradosDisponibles.map(g => <option key={g} value={g}>{g}</option>)}
//               </select>

//               <select value={grupo} onChange={e => setGrupo(e.target.value)}>
//                 <option value="">-- Seleccione Grupo --</option>
//                 {gruposDisponibles.map(gr => <option key={gr} value={gr}>{gr}</option>)}
//               </select>

//               <input type="date" value={fecha} onChange={e => setFecha(e.target.value)} />
//             </div>

//             <div className="buttons">
//               <button type="submit">Guardar</button>
//               {editingId && <button type="button" onClick={resetForm}>Cancelar</button>}
//             </div>
//           </form>

//           <div className="acciones-tabla">
//             <button onClick={handleEnviarTabla} className="pdf-btn">Enviar al Profesor</button>
//           </div>

//           {/* Tabla de Horario */}
//           <div className="table-responsive">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Día</th><th>Periodo</th><th>Hora</th><th>Materia</th><th>Grado</th><th>Grupo</th><th>Aula</th><th>Acciones</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {horario.length === 0 ? <tr><td colSpan="8">No hay horario</td></tr> :
//                   horario.map(h => (
//                     <tr key={h.id}>
//                       <td>{h.dia}</td>
//                       <td>{h.periodo}</td>
//                       <td>{h.hora_inicio} - {h.hora_fin}</td>
//                       <td>{h.materia}</td>
//                       <td>{h.grado}</td>
//                       <td>{h.grupo}</td>
//                       <td>{h.aula || "N/A"}</td>
//                       <td>
//                         <button onClick={() => handleEditar(h)}>Editar</button>
//                         <button onClick={() => handleEliminar(h.id)}>Eliminar</button>
//                       </td>
//                     </tr>
//                   ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Consulta entre fechas */}
//           <div className="consulta">
//             <h2>📊 Consulta de Horas entre Fechas</h2>
//             <div className="grid-form">
//               <select value={consultaProfesor} onChange={e => setConsultaProfesor(e.target.value)}>
//                 <option value="">-- Profesor --</option>
//                 {profesores.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
//               </select>
//               <select value={consultaGrado} onChange={e => setConsultaGrado(e.target.value)}>
//                 <option value="Todos">-- Todos los Grados --</option>
//                 {gradosDisponibles.map(g => <option key={g} value={g}>{g}</option>)}
//               </select>
//               <select value={consultaGrupo} onChange={e => setConsultaGrupo(e.target.value)}>
//                 <option value="Todos">-- Todos los Grupos --</option>
//                 {gruposDisponibles.map(gr => <option key={gr} value={gr}>{gr}</option>)}
//               </select>
//               <input type="date" value={consultaFechaInicio} onChange={e => setConsultaFechaInicio(e.target.value)} />
//               <input type="date" value={consultaFechaFin} onChange={e => setConsultaFechaFin(e.target.value)} />
//               <button onClick={handleConsulta}>Consultar</button>
//             </div>

//             {horasConsulta.length > 0 && (
//               <div>
//                 <div className="acciones-tabla">
//                   <button onClick={handleDescargarPDF} className="pdf-btn">PDF</button>
//                   <button onClick={handleDescargarExcel} className="pdf-btn">Excel</button>
//                 </div>

//                 <div className="table-responsive">
//                   <table>
//                     <thead>
//                       <tr><th>Día</th><th>Hora</th><th>Materia</th><th>Horas</th></tr>
//                     </thead>
//                     <tbody>
//                       {horasConsulta.map((h, i) => (
//                         <tr key={i}>
//                           <td>{h.dia}</td>
//                           <td>{h.hora_inicio} - {h.hora_fin}</td>
//                           <td>{h.materia}</td>
//                           <td>{h.horas} hrs</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }



//

// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import "../../style/CrearHorarioRector.css";
// import { useAuth } from "../../context/AuthContext";

// // const API = process.env.REACT_APP_API || "http://localhost:5001/api";

// const API = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";

// export default function RectorHorario() {
//   const { token, user } = useAuth();

//   const multitenantHeaders = {
//     Authorization: `Bearer ${token}`,
//     "tenant-id": user?.tenant_id,
//     "sede-id": user?.sede_id,
//   };

//   const [profesores, setProfesores] = useState([]);
//   const [profesorId, setProfesorId] = useState("");
//   const [asignaciones, setAsignaciones] = useState([]);
//   const [horario, setHorario] = useState([]);
//   const [editingId, setEditingId] = useState(null);

//   const [asignacionId, setAsignacionId] = useState("");
//   const [dia, setDia] = useState("");
//   const [horaInicio, setHoraInicio] = useState("");
//   const [horaFin, setHoraFin] = useState("");
//   const [aula, setAula] = useState("");
//   const [periodo, setPeriodo] = useState("");
//   const [grado, setGrado] = useState("");
//   const [grupo, setGrupo] = useState("");
//   const [fecha, setFecha] = useState("");

//   const [consultaProfesor, setConsultaProfesor] = useState("");
//   const [consultaGrado, setConsultaGrado] = useState("Todos");
//   const [consultaGrupo, setConsultaGrupo] = useState("Todos");
//   const [consultaFechaInicio, setConsultaFechaInicio] = useState("");
//   const [consultaFechaFin, setConsultaFechaFin] = useState("");
//   const [horasConsulta, setHorasConsulta] = useState([]);

//   const [gradosDisponibles, setGradosDisponibles] = useState([]);
//   const [gruposDisponibles, setGruposDisponibles] = useState([]);

//   const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];
//   const PERIODOS = ["Primer", "Segundo", "Tercer", "Cuarto"];

//   // ---------------------------
//   // 📌 Cargar profesores
//   // ---------------------------
//   useEffect(() => {
//     axios
//       .get(`${API}/horario/profesores`, { headers: multitenantHeaders })
//       .then((res) => setProfesores(res.data || []))
//       .catch((err) => console.error("Error cargando profesores:", err));
//   }, []);

//   // ---------------------------
//   // 📌 Cargar asignaciones y horario
//   // ---------------------------
//   useEffect(() => {
//     if (!profesorId) return;

//     axios
//       .get(`${API}/horario/asignaciones/${profesorId}`, {
//         headers: multitenantHeaders,
//       })
//       .then((res) => {
//         const data = res.data || [];
//         setAsignaciones(data);
//         setGradosDisponibles([...new Set(data.map((a) => a.grado))]);
//         setGruposDisponibles([...new Set(data.map((a) => a.grupo))]);
//       })
//       .catch((err) => console.error("Error cargando asignaciones:", err));

//     fetchHorario();
//   }, [profesorId]);

//   const fetchHorario = () => {
//     axios
//       .get(`${API}/horario/${profesorId}`, { headers: multitenantHeaders })
//       .then((res) => setHorario(res.data || []))
//       .catch((err) => console.error("Error cargando horario:", err));
//   };

//   // ---------------------------
//   // 📌 Guardar horario (insert o update)
//   // ---------------------------
//   const handleGuardar = async (e) => {
//     e.preventDefault();

//     if (
//       !profesorId ||
//       !asignacionId ||
//       !dia ||
//       !horaInicio ||
//       !horaFin ||
//       !periodo ||
//       !grado ||
//       !grupo ||
//       !fecha
//     ) {
//       return alert("Todos los campos son obligatorios");
//     }

//     const payload = {
//       profesor_id: profesorId,
//       asignacion_id: asignacionId,
//       dia,
//       hora_inicio: horaInicio,
//       hora_fin: horaFin,
//       aula,
//       periodo,
//       grado,
//       grupo,
//       fecha,
//       tenant_id: user?.tenant_id,
//       sede_id: user?.sede_id,
//     };

//     try {
//       if (editingId) {
//         await axios.put(`${API}/horario/${editingId}`, payload, {
//           headers: multitenantHeaders,
//         });
//       } else {
//         await axios.post(`${API}/horario`, payload, {
//           headers: multitenantHeaders,
//         });
//       }

//       fetchHorario();
//       resetForm();
//     } catch (err) {
//       console.error("Error guardando horario:", err);
//       alert("Error al guardar horario");
//     }
//   };

//   const resetForm = () => {
//     setAsignacionId("");
//     setDia("");
//     setHoraInicio("");
//     setHoraFin("");
//     setAula("");
//     setPeriodo("");
//     setGrado("");
//     setGrupo("");
//     setFecha("");
//     setEditingId(null);
//   };

//   const handleEditar = (h) => {
//     setEditingId(h.id);
//     setAsignacionId(h.asignacion_id);
//     setDia(h.dia);
//     setHoraInicio(h.hora_inicio);
//     setHoraFin(h.hora_fin);
//     setAula(h.aula || "");
//     setPeriodo(h.periodo);
//     setGrado(h.grado);
//     setGrupo(h.grupo);
//     setFecha(h.fecha);
//   };

//   const handleEliminar = async (id) => {
//     if (!window.confirm("¿Eliminar este horario?")) return;

//     try {
//       await axios.delete(`${API}/horario/${id}`, {
//         headers: multitenantHeaders,
//       });
//       fetchHorario();
//     } catch (err) {
//       console.error("Error eliminando horario:", err);
//       alert("Error al eliminar");
//     }
//   };

//   // ---------------------------
//   // 📌 Enviar horario al módulo del profesor
//   // ---------------------------
//   const handleEnviarTabla = async () => {
//     try {
//       await axios.post(
//         `${API}/horario/enviar-tabla`, // ✅ ruta corregida
//         { profesorId, horario },
//         { headers: multitenantHeaders }
//       );
//       alert("✅ Horario enviado al profesor");
//     } catch (err) {
//       console.error("Error enviando tabla:", err);
//       alert("Error enviando horario");
//     }
//   };

//   // ---------------------------
//   // 📌 Consulta de horas entre fechas
//   // ---------------------------
//   const handleConsulta = async () => {
//     if (!consultaProfesor || !consultaFechaInicio || !consultaFechaFin)
//       return alert("Debe seleccionar profesor y rango de fechas");

//     try {
//       const gradoParam = consultaGrado === "Todos" ? "all" : consultaGrado;
//       const grupoParam = consultaGrupo === "Todos" ? "all" : consultaGrupo;

//       const res = await axios.get(
//         `${API}/horario/consulta/${consultaProfesor}/${gradoParam}/${grupoParam}`,
//         {
//           headers: multitenantHeaders,
//           params: {
//             fecha_inicio: consultaFechaInicio,
//             fecha_fin: consultaFechaFin,
//           },
//         }
//       );

//       setHorasConsulta(res.data.detalle || []);
//     } catch (err) {
//       console.error("Error realizando consulta:", err);
//       alert("No se pudo realizar la consulta");
//     }
//   };

//   const handleDescargarPDF = () => {
//     const gradoParam = consultaGrado === "Todos" ? "all" : consultaGrado;
//     const grupoParam = consultaGrupo === "Todos" ? "all" : consultaGrupo;

//     window.open(
//       `${API}/horario/consulta/${consultaProfesor}/${gradoParam}/${grupoParam}/pdf?fecha_inicio=${consultaFechaInicio}&fecha_fin=${consultaFechaFin}`,
//       "_blank"
//     );
//   };

//   const handleDescargarExcel = () => {
//     const gradoParam = consultaGrado === "Todos" ? "all" : consultaGrado;
//     const grupoParam = consultaGrupo === "Todos" ? "all" : consultaGrupo;

//     window.open(
//       `${API}/horario/consulta/${consultaProfesor}/${gradoParam}/${grupoParam}/excel?fecha_inicio=${consultaFechaInicio}&fecha_fin=${consultaFechaFin}`,
//       "_blank"
//     );
//   };

//   return (
//     <div className="container">
//       <h1>📅 Gestión de Horarios (Rector)</h1>

//       {/* Selección profesor */}
//       <div className="form-group">
//         <label>Profesor:</label>
//         <select
//           value={profesorId}
//           onChange={(e) => setProfesorId(e.target.value)}
//         >
//           <option value="">-- Seleccione --</option>
//           {profesores.map((p) => (
//             <option key={p.id} value={p.id}>
//               {p.nombre}
//             </option>
//           ))}
//         </select>
//       </div>

//       {profesorId && (
//         <>
//           {/* Formulario del horario */}
//           <form onSubmit={handleGuardar} className="form-horario">
//             <h2>
//               {editingId ? "✏️ Editar Horario" : "➕ Agregar Horario"}
//             </h2>

//             <div className="grid-form">
//               <select
//                 value={asignacionId}
//                 onChange={(e) => setAsignacionId(e.target.value)}
//               >
//                 <option value="">-- Seleccione Asignación --</option>
//                 {asignaciones.map((a) => (
//                   <option key={a.id} value={a.id}>
//                     {a.materia} | {a.grado} | {a.grupo}
//                   </option>
//                 ))}
//               </select>

//               <select value={dia} onChange={(e) => setDia(e.target.value)}>
//                 <option value="">-- Día --</option>
//                 {DIAS.map((d) => (
//                   <option key={d} value={d}>
//                     {d}
//                   </option>
//                 ))}
//               </select>

//               <select
//                 value={periodo}
//                 onChange={(e) => setPeriodo(e.target.value)}
//               >
//                 <option value="">-- Periodo --</option>
//                 {PERIODOS.map((p) => (
//                   <option key={p} value={p}>
//                     {p} Periodo
//                   </option>
//                 ))}
//               </select>

//               <input
//                 type="time"
//                 value={horaInicio}
//                 onChange={(e) => setHoraInicio(e.target.value)}
//               />
//               <input
//                 type="time"
//                 value={horaFin}
//                 onChange={(e) => setHoraFin(e.target.value)}
//               />
//               <input
//                 type="text"
//                 placeholder="Aula"
//                 value={aula}
//                 onChange={(e) => setAula(e.target.value)}
//               />

//               <select
//                 value={grado}
//                 onChange={(e) => setGrado(e.target.value)}
//               >
//                 <option value="">-- Seleccione Grado --</option>
//                 {gradosDisponibles.map((g) => (
//                   <option key={g} value={g}>
//                     {g}
//                   </option>
//                 ))}
//               </select>

//               <select
//                 value={grupo}
//                 onChange={(e) => setGrupo(e.target.value)}
//               >
//                 <option value="">-- Seleccione Grupo --</option>
//                 {gruposDisponibles.map((gr) => (
//                   <option key={gr} value={gr}>
//                     {gr}
//                   </option>
//                 ))}
//               </select>

//               <input
//                 type="date"
//                 value={fecha}
//                 onChange={(e) => setFecha(e.target.value)}
//               />
//             </div>

//             <div className="buttons">
//               <button type="submit">Guardar</button>
//               {editingId && (
//                 <button type="button" onClick={resetForm}>
//                   Cancelar
//                 </button>
//               )}
//             </div>
//           </form>

//           {/* Enviar al profesor */}
//           <div className="acciones-tabla">
//             <button onClick={handleEnviarTabla} className="pdf-btn">
//               Enviar al Profesor
//             </button>
//           </div>

//           {/* Tabla horarios */}
//           <div className="table-responsive">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Día</th>
//                   <th>Periodo</th>
//                   <th>Hora</th>
//                   <th>Materia</th>
//                   <th>Grado</th>
//                   <th>Grupo</th>
//                   <th>Aula</th>
//                   <th>Acciones</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {horario.length === 0 ? (
//                   <tr>
//                     <td colSpan="8">No hay horario</td>
//                   </tr>
//                 ) : (
//                   horario.map((h) => (
//                     <tr key={h.id}>
//                       <td>{h.dia}</td>
//                       <td>{h.periodo}</td>
//                       <td>
//                         {h.hora_inicio} - {h.hora_fin}
//                       </td>
//                       <td>{h.materia}</td>
//                       <td>{h.grado}</td>
//                       <td>{h.grupo}</td>
//                       <td>{h.aula || "N/A"}</td>
//                       <td>
//                         <button onClick={() => handleEditar(h)}>Editar</button>
//                         <button onClick={() => handleEliminar(h.id)}>
//                           Eliminar
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Consulta por fechas */}
//           <div className="consulta">
//             <h2>📊 Consulta de Horas entre Fechas</h2>

//             <div className="grid-form">
//               <select
//                 value={consultaProfesor}
//                 onChange={(e) => setConsultaProfesor(e.target.value)}
//               >
//                 <option value="">-- Profesor --</option>
//                 {profesores.map((p) => (
//                   <option key={p.id} value={p.id}>
//                     {p.nombre}
//                   </option>
//                 ))}
//               </select>

//               <select
//                 value={consultaGrado}
//                 onChange={(e) => setConsultaGrado(e.target.value)}
//               >
//                 <option value="Todos">-- Todos los Grados --</option>
//                 {gradosDisponibles.map((g) => (
//                   <option key={g} value={g}>
//                     {g}
//                   </option>
//                 ))}
//               </select>

//               <select
//                 value={consultaGrupo}
//                 onChange={(e) => setConsultaGrupo(e.target.value)}
//               >
//                 <option value="Todos">-- Todos los Grupos --</option>
//                 {gruposDisponibles.map((gr) => (
//                   <option key={gr} value={gr}>
//                     {gr}
//                   </option>
//                 ))}
//               </select>

//               <input
//                 type="date"
//                 value={consultaFechaInicio}
//                 onChange={(e) => setConsultaFechaInicio(e.target.value)}
//               />
//               <input
//                 type="date"
//                 value={consultaFechaFin}
//                 onChange={(e) => setConsultaFechaFin(e.target.value)}
//               />

//               <button onClick={handleConsulta}>Consultar</button>
//             </div>

//             {horasConsulta.length > 0 && (
//               <div>
//                 <div className="acciones-tabla">
//                   <button onClick={handleDescargarPDF} className="pdf-btn">
//                     PDF
//                   </button>
//                   <button onClick={handleDescargarExcel} className="pdf-btn">
//                     Excel
//                   </button>
//                 </div>

//                 <div className="table-responsive">
//                   <table>
//                     <thead>
//                       <tr>
//                         <th>Día</th>
//                         <th>Hora</th>
//                         <th>Materia</th>
//                         <th>Horas</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {horasConsulta.map((h, i) => (
//                         <tr key={i}>
//                           <td>{h.dia}</td>
//                           <td>
//                             {h.hora_inicio} - {h.hora_fin}
//                           </td>
//                           <td>{h.materia}</td>
//                           <td>{h.horas} hrs</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }


////

import React, { useEffect, useState, useCallback } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { API } from "../config"; // ✅ Importación centralizada
import "../../style/CrearHorarioRector.css";

export default function RectorHorario() {
  const { token, user } = useAuth();

  // Encabezados multitenant consistentes
  const multitenantHeaders = {
    Authorization: `Bearer ${token}`,
    "x-tenant-id": user?.tenant_id,
    "x-sede-id": user?.sede_id,
  };

  // Estados de datos
  const [profesores, setProfesores] = useState([]);
  const [profesorId, setProfesorId] = useState("");
  const [asignaciones, setAsignaciones] = useState([]);
  const [horario, setHorario] = useState([]);
  const [editingId, setEditingId] = useState(null);

  // Estados del formulario
  const [asignacionId, setAsignacionId] = useState("");
  const [dia, setDia] = useState("");
  const [horaInicio, setHoraInicio] = useState("");
  const [horaFin, setHoraFin] = useState("");
  const [aula, setAula] = useState("");
  const [periodo, setPeriodo] = useState("");
  const [grado, setGrado] = useState("");
  const [grupo, setGrupo] = useState("");
  const [fecha, setFecha] = useState("");

  // Estados de consulta
  const [consultaProfesor, setConsultaProfesor] = useState("");
  const [consultaGrado, setConsultaGrado] = useState("Todos");
  const [consultaGrupo, setConsultaGrupo] = useState("Todos");
  const [consultaFechaInicio, setConsultaFechaInicio] = useState("");
  const [consultaFechaFin, setConsultaFechaFin] = useState("");
  const [horasConsulta, setHorasConsulta] = useState([]);

  const [gradosDisponibles, setGradosDisponibles] = useState([]);
  const [gruposDisponibles, setGruposDisponibles] = useState([]);

  const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];
  const PERIODOS = ["Primer", "Segundo", "Tercer", "Cuarto"];

  /* =========================================
      🔄 CARGA DE DATOS (FETCH)
  ========================================= */
  
  // Cargar lista de profesores al iniciar
  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/horario/profesores`, { headers: multitenantHeaders })
        .then((res) => setProfesores(res.data || []))
        .catch((err) => console.error("Error cargando profesores:", err));
    }
  }, [token]);

  // Función para traer el horario del profesor seleccionado
  const fetchHorario = useCallback(() => {
    if (!profesorId) return;
    axios
      .get(`${API}/horario/${profesorId}`, { headers: multitenantHeaders })
      .then((res) => setHorario(res.data || []))
      .catch((err) => console.error("Error cargando horario:", err));
  }, [profesorId]);

  // Cargar asignaciones cuando cambia el profesor
  useEffect(() => {
    if (!profesorId) {
      setAsignaciones([]);
      setHorario([]);
      return;
    }

    axios
      .get(`${API}/horario/asignaciones/${profesorId}`, { headers: multitenantHeaders })
      .then((res) => {
        const data = res.data || [];
        setAsignaciones(data);
        setGradosDisponibles([...new Set(data.map((a) => a.grado))]);
        setGruposDisponibles([...new Set(data.map((a) => a.grupo))]);
      })
      .catch((err) => console.error("Error cargando asignaciones:", err));

    fetchHorario();
  }, [profesorId, fetchHorario]);

  /* =========================================
      💾 GESTIÓN DE HORARIO (CRUD)
  ========================================= */

  const handleGuardar = async (e) => {
    e.preventDefault();

    if (!profesorId || !asignacionId || !dia || !horaInicio || !horaFin || !periodo || !fecha) {
      return alert("Por favor complete los campos obligatorios");
    }

    const payload = {
      profesor_id: profesorId,
      asignacion_id: asignacionId,
      dia,
      hora_inicio: horaInicio,
      hora_fin: horaFin,
      aula,
      periodo,
      grado,
      grupo,
      fecha,
    };

    try {
      if (editingId) {
        await axios.put(`${API}/horario/${editingId}`, payload, { headers: multitenantHeaders });
      } else {
        await axios.post(`${API}/horario`, payload, { headers: multitenantHeaders });
      }
      alert("✅ Horario guardado correctamente");
      fetchHorario();
      resetForm();
    } catch (err) {
      alert("Error al guardar: " + (err.response?.data?.msg || "Error de servidor"));
    }
  };

  const resetForm = () => {
    setAsignacionId("");
    setDia("");
    setHoraInicio("");
    setHoraFin("");
    setAula("");
    setPeriodo("");
    setGrado("");
    setGrupo("");
    setFecha("");
    setEditingId(null);
  };

  const handleEditar = (h) => {
    setEditingId(h.id);
    setAsignacionId(h.asignacion_id);
    setDia(h.dia);
    setHoraInicio(h.hora_inicio);
    setHoraFin(h.hora_fin);
    setAula(h.aula || "");
    setPeriodo(h.periodo);
    setGrado(h.grado);
    setGrupo(h.grupo);
    setFecha(h.fecha ? h.fecha.split("T")[0] : ""); // Formatear fecha para input date
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Está seguro de eliminar este registro del horario?")) return;
    try {
      await axios.delete(`${API}/horario/${id}`, { headers: multitenantHeaders });
      fetchHorario();
    } catch (err) {
      alert("Error al eliminar");
    }
  };

  const handleEnviarTabla = async () => {
    try {
      await axios.post(
        `${API}/horario/enviar-tabla`,
        { profesorId, horario },
        { headers: multitenantHeaders }
      );
      alert("✅ Horario sincronizado con el panel del profesor");
    } catch (err) {
      alert("Error al enviar el horario");
    }
  };

  /* =========================================
      📊 CONSULTAS Y REPORTES
  ========================================= */

  const handleConsulta = async () => {
    if (!consultaProfesor || !consultaFechaInicio || !consultaFechaFin)
      return alert("Seleccione profesor y rango de fechas completo");

    try {
      const g = consultaGrado === "Todos" ? "all" : consultaGrado;
      const gr = consultaGrupo === "Todos" ? "all" : consultaGrupo;

      const res = await axios.get(`${API}/horario/consulta/${consultaProfesor}/${g}/${gr}`, {
        headers: multitenantHeaders,
        params: { fecha_inicio: consultaFechaInicio, fecha_fin: consultaFechaFin },
      });
      setHorasConsulta(res.data.detalle || []);
    } catch (err) {
      alert("Error en la consulta");
    }
  };

  // Helper para descargas
  const descargarReporte = (tipo) => {
    const g = consultaGrado === "Todos" ? "all" : consultaGrado;
    const gr = consultaGrupo === "Todos" ? "all" : consultaGrupo;
    const url = `${API}/horario/consulta/${consultaProfesor}/${g}/${gr}/${tipo}?fecha_inicio=${consultaFechaInicio}&fecha_fin=${consultaFechaFin}&tenant_id=${user.tenant_id}`;
    window.open(url, "_blank");
  };

  return (
    <div className="container-rector">
      <h1>📅 Gestión de Horarios Académicos</h1>

      <section className="config-card">
        <label>Seleccionar Profesor para gestionar:</label>
        <select value={profesorId} onChange={(e) => setProfesorId(e.target.value)}>
          <option value="">-- Seleccione un docente --</option>
          {profesores.map((p) => (
            <option key={p.id} value={p.id}>{p.nombre}</option>
          ))}
        </select>
      </section>

      {profesorId && (
        <>
          <form onSubmit={handleGuardar} className="form-horario">
            <h3>{editingId ? "✏️ Editando Registro" : "➕ Nuevo Registro de Horario"}</h3>
            <div className="grid-form">
              <div className="field">
                <label>Asignación:</label>
                <select value={asignacionId} onChange={(e) => setAsignacionId(e.target.value)}>
                  <option value="">-- Materia / Grado --</option>
                  {asignaciones.map((a) => (
                    <option key={a.id} value={a.id}>{a.materia} - {a.grado}°{a.grupo}</option>
                  ))}
                </select>
              </div>

              <div className="field">
                <label>Día:</label>
                <select value={dia} onChange={(e) => setDia(e.target.value)}>
                  <option value="">-- Día --</option>
                  {DIAS.map((d) => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>

              <div className="field">
                <label>Periodo:</label>
                <select value={periodo} onChange={(e) => setPeriodo(e.target.value)}>
                  <option value="">-- Periodo --</option>
                  {PERIODOS.map((p) => <option key={p} value={p}>{p} Periodo</option>)}
                </select>
              </div>

              <div className="field">
                <label>Hora Inicio:</label>
                <input type="time" value={horaInicio} onChange={(e) => setHoraInicio(e.target.value)} />
              </div>

              <div className="field">
                <label>Hora Fin:</label>
                <input type="time" value={horaFin} onChange={(e) => setHoraFin(e.target.value)} />
              </div>

              <div className="field">
                <label>Aula:</label>
                <input type="text" placeholder="Ej: Laboratorio 1" value={aula} onChange={(e) => setAula(e.target.value)} />
              </div>

              <div className="field">
                <label>Grado:</label>
                <select value={grado} onChange={(e) => setGrado(e.target.value)}>
                  <option value="">-- Grado --</option>
                  {gradosDisponibles.map((g) => <option key={g} value={g}>{g}</option>)}
                </select>
              </div>

              <div className="field">
                <label>Grupo:</label>
                <select value={grupo} onChange={(e) => setGrupo(e.target.value)}>
                  <option value="">-- Grupo --</option>
                  {gruposDisponibles.map((gr) => <option key={gr} value={gr}>{gr}</option>)}
                </select>
              </div>

              <div className="field">
                <label>Fecha Efectiva:</label>
                <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-save">{editingId ? "Actualizar" : "Guardar Registro"}</button>
              {editingId && <button type="button" className="btn-cancel" onClick={resetForm}>Cancelar</button>}
            </div>
          </form>

          <div className="table-section">
            <div className="table-header">
              <h3>Horario Actual del Docente</h3>
              <button onClick={handleEnviarTabla} className="btn-sync">Sincronizar con Profesor</button>
            </div>
            <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Día</th>
                    <th>Periodo</th>
                    <th>Hora</th>
                    <th>Materia</th>
                    <th>Ubicación</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {horario.length === 0 ? (
                    <tr><td colSpan="6">No hay registros cargados</td></tr>
                  ) : (
                    horario.map((h) => (
                      <tr key={h.id}>
                        <td>{h.dia}</td>
                        <td>{h.periodo}</td>
                        <td>{h.hora_inicio} - {h.hora_fin}</td>
                        <td>{h.materia} ({h.grado}°{h.grupo})</td>
                        <td>{h.aula || "Por definir"}</td>
                        <td>
                          <button className="btn-edit-small" onClick={() => handleEditar(h)}>📝</button>
                          <button className="btn-delete-small" onClick={() => handleEliminar(h.id)}>🗑️</button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <section className="consulta-reportes">
            <h2>📊 Reporte de Horas Laboradas</h2>
            <div className="grid-form">
              <select value={consultaProfesor} onChange={(e) => setConsultaProfesor(e.target.value)}>
                <option value="">-- Seleccionar Profesor --</option>
                {profesores.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}
              </select>
              <input type="date" value={consultaFechaInicio} onChange={(e) => setConsultaFechaInicio(e.target.value)} />
              <input type="date" value={consultaFechaFin} onChange={(e) => setConsultaFechaFin(e.target.value)} />
              <button onClick={handleConsulta} className="btn-search">Consultar Detalle</button>
            </div>

            {horasConsulta.length > 0 && (
              <div className="resultados-consulta">
                <div className="descargas">
                  <button onClick={() => descargarReporte('pdf')} className="btn-pdf">Exportar PDF</button>
                  <button onClick={() => descargarReporte('excel')} className="btn-excel">Exportar Excel</button>
                </div>
                <div className="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th>Fecha/Día</th>
                        <th>Hora</th>
                        <th>Materia</th>
                        <th>Carga</th>
                      </tr>
                    </thead>
                    <tbody>
                      {horasConsulta.map((h, i) => (
                        <tr key={i}>
                          <td>{h.dia}</td>
                          <td>{h.hora_inicio} - {h.hora_fin}</td>
                          <td>{h.materia}</td>
                          <td>{h.horas} hrs</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </section>
        </>
      )}
    </div>
  );
}